import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  titleStyle: {
    fontFamily: 'MANEurope, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(38),
    fontWeight: 'bold',
    color: '#fff',
    lineHeight: 1.16,
    textShadow: '0 0 8px rgba(0, 0, 0, 0.1)'
  }
})

const Title = ({
  classes: { titleStyle },
  className,
  component,
  children,
  ...otherProps
}) => {
  const titleClass = classNames(titleStyle, className)
  return (
    <Typography
      component={component || 'h2'}
      className={titleClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

Title.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node
}

export default withStyles(styles)(Title)



// WEBPACK FOOTER //
// ./src/styleguide/Title.js